/**
 * Lao copy for shared UX infrastructure: preferences, errors, session, accessibility, tables
 * and the command palette. Merged into the same dictionary as lao.ts (lao.ts wins on clashes).
 * Kept in its own file so parallel additions to lao.ts never create duplicate keys.
 */
export const laoUx: Record<string, string> = {
  'Request ID copied': 'ສຳເນົາລະຫັດຄຳຮ້ອງແລ້ວ',
  'Guest message notifications are unavailable. Open the inbox to retry.':
    'ບໍ່ສາມາດໂຫຼດແຈ້ງເຕືອນຂໍ້ຄວາມແຂກ. ເປີດກ່ອງຂໍ້ຄວາມເພື່ອລອງໃໝ່.',
  'Stock notifications are unavailable. Try again.': 'ບໍ່ສາມາດໂຫຼດແຈ້ງເຕືອນສາງສິນຄ້າ. ລອງໃໝ່.',
  'Role updated': 'ອັບເດດສິດແລ້ວ',
  'Invitation copied': 'ສຳເນົາຄຳເຊີນແລ້ວ',
  'Member added': 'ເພີ່ມສະມາຊິກແລ້ວ',
  'Access removed': 'ຖອນສິດເຂົ້າໃຊ້ແລ້ວ',
  'Release metadata updated': 'ອັບເດດຂໍ້ມູນຮຸ່ນແລ້ວ',
  'Payroll marked paid': 'ໝາຍວ່າຈ່າຍເງິນເດືອນແລ້ວ',
  'Allow popups to print documents': 'ອະນຸຍາດໜ້າຕ່າງປັອບອັບເພື່ອພິມເອກະສານ',
  'records imported': 'ລາຍການທີ່ນຳເຂົ້າແລ້ວ',
  posted: 'ລົງບັນຊີແລ້ວ',
  converted: 'ປ່ຽນແລ້ວ',
  voided: 'ຍົກເລີກແລ້ວ',
  reopened: 'ເປີດຄືນແລ້ວ',
  updated: 'ອັບເດດແລ້ວ',
  'Choose month': 'ເລືອກເດືອນ',
  'Choose year': 'ເລືອກປີ',
  'Notification Center': 'ສູນແຈ້ງເຕືອນ',
  'Notification settings': 'ຕັ້ງຄ່າການແຈ້ງເຕືອນ',
  notifications: 'ການແຈ້ງເຕືອນ',
  'Choose what reaches you': 'ເລືອກການແຈ້ງເຕືອນທີ່ຕ້ອງການ',
  'Back to notifications': 'ກັບໄປການແຈ້ງເຕືອນ',
  'Close notifications': 'ປິດການແຈ້ງເຕືອນ',
  'Guest message': 'ຂໍ້ຄວາມແຂກ',
  'Stock alerts': 'ແຈ້ງເຕືອນສາງສິນຄ້າ',
  'New messages from your guests': 'ຂໍ້ຄວາມໃໝ່ຈາກແຂກ',
  'Products that need replenishing': 'ສິນຄ້າທີ່ຕ້ອງຕື່ມ',
  'Guest message banners': 'ປ້າຍແຈ້ງຂໍ້ຄວາມແຂກ',
  'Show new guest messages at the top-right': 'ສະແດງຂໍ້ຄວາມແຂກໃໝ່ຢູ່ເທິງຂວາ',
  'Show message previews': 'ສະແດງຕົວຢ່າງຂໍ້ຄວາມ',
  'Include guest names and message text': 'ສະແດງຊື່ແຂກ ແລະ ເນື້ອຫາຂໍ້ຄວາມ',
  'Saved for this account and workspace in this browser.':
    'ບັນທຶກສຳລັບບັນຊີ ແລະ ທຸລະກິດນີ້ໃນບຣາວເຊີນີ້.',
  Active: 'ປັດຈຸບັນ',
  Dismissed: 'ປິດແລ້ວ',
  'Clear all': 'ປິດທັງໝົດ',
  'Restore all': 'ກູ້ຄືນທັງໝົດ',
  'Notifications cleared': 'ປິດການແຈ້ງເຕືອນແລ້ວ',
  'Notifications restored': 'ກູ້ຄືນການແຈ້ງເຕືອນແລ້ວ',
  'Messages marked as read': 'ໝາຍຂໍ້ຄວາມວ່າອ່ານແລ້ວ',
  'Loading notifications…': 'ກຳລັງໂຫຼດການແຈ້ງເຕືອນ…',
  'Mark all as read': 'ໝາຍທັງໝົດວ່າອ່ານແລ້ວ',
  'Mark as read': 'ໝາຍວ່າອ່ານແລ້ວ',
  'Dismiss notification': 'ປິດການແຈ້ງເຕືອນ',
  'You’re all caught up': 'ທ່ານເບິ່ງຄົບແລ້ວ',
  'No dismissed notifications': 'ບໍ່ມີການແຈ້ງເຕືອນທີ່ປິດ',
  'New updates will appear here.': 'ລາຍການໃໝ່ຈະປາກົດຢູ່ນີ້.',
  'Open the inbox to view this message.': 'ເປີດກ່ອງຂໍ້ຄວາມເພື່ອເບິ່ງຂໍ້ຄວາມນີ້.',
  'Clearing alerts keeps messages unread and stock issues open.':
    'ການປິດແຈ້ງເຕືອນບໍ່ໝາຍຂໍ້ຄວາມວ່າອ່ານແລ້ວ ຫຼື ແກ້ໄຂສາງສິນຄ້າ.',
  'Your browser could not save these preferences. They will reset after reload.':
    'ບຣາວເຊີບັນທຶກການຕັ້ງຄ່າບໍ່ໄດ້. ຄ່າຈະກັບຄືນເມື່ອໂຫຼດໜ້າໃໝ່.',
  // Shared create/edit forms
  'Save & review': 'ບັນທຶກ ແລະ ກວດສອບ',
  'Not saved yet': 'ຍັງບໍ່ບັນທຶກ',
  'Draft saved': 'ບັນທຶກຮ່າງແລ້ວ',
  'Draft saved · attachments pending': 'ບັນທຶກຮ່າງແລ້ວ · ໄຟລ໌ແນບລໍຖ້າອັບໂຫຼດ',
  'Drafts can be reviewed before posting.': 'ສາມາດກວດສອບຮ່າງກ່ອນລົງບັນຊີ.',
  'Valid until': 'ໃຊ້ໄດ້ເຖິງວັນທີ',
  'Quotation validity': 'ໄລຍະໃຊ້ໄດ້ຂອງໃບສະເໜີລາຄາ',
  'Open draft': 'ເປີດຮ່າງ',
  'Add custom item': 'ເພີ່ມລາຍການກຳນົດເອງ',
  'Keep customer for next document': 'ຮັກສາລູກຄ້າສຳລັບເອກະສານຖັດໄປ',
  'Dates, currency and account settings stay selected.':
    'ຮັກສາວັນທີ, ສະກຸນເງິນ ແລະ ການຕັ້ງຄ່າບັນຊີທີ່ເລືອກໄວ້.',
  'Keyboard shortcuts': 'ປຸ່ມລັດແປ້ນພິມ',
  'Complete required fields and correct the highlighted values.':
    'ປ້ອນຊ່ອງທີ່ຈຳເປັນໃຫ້ຄົບ ແລະ ແກ້ໄຂຄ່າທີ່ເນັ້ນໄວ້.',
  'Enter: next field · ⌘ / Ctrl + Enter: save': 'Enter: ຊ່ອງຖັດໄປ · ⌘ / Ctrl + Enter: ບັນທຶກ',
  'Next field': 'ຊ່ອງຖັດໄປ',
  'Previous field': 'ຊ່ອງກ່ອນໜ້າ',
  'Next field · new row after the last value': 'ຊ່ອງຖັດໄປ · ເພີ່ມແຖວຫຼັງຄ່າສຸດທ້າຍ',
  'Navigate all controls': 'ເລື່ອນຜ່ານທຸກປຸ່ມ ແລະ ຊ່ອງ',
  'Choose an option': 'ເລືອກລາຍການ',
  'Open calendar': 'ເປີດປະຕິທິນ',
  'Product / custom item': 'ສິນຄ້າ / ລາຍການກຳນົດເອງ',
  'F2 switches product / custom item': 'F2 ສະຫຼັບສິນຄ້າ / ລາຍການກຳນົດເອງ',
  'Alt + Enter adds an item': 'Alt + Enter ເພີ່ມລາຍການ',
  'Alt + ↓ opens calendar': 'Alt + ↓ ເປີດປະຕິທິນ',
  'Enter a valid date within the allowed range': 'ປ້ອນວັນທີທີ່ຖືກຕ້ອງພາຍໃນຊ່ວງທີ່ກຳນົດ',
  'Save & new': 'ບັນທຶກ ແລະ ສ້າງໃໝ່',
  'Esc to cancel': 'Esc ເພື່ອຍົກເລີກ',
  'Save and continue entering documents. Review drafts before posting.':
    'ບັນທຶກ ແລະ ປ້ອນເອກະສານຕໍ່. ກວດສອບຮ່າງກ່ອນລົງບັນຊີ.',
  'Ready for entry': 'ພ້ອມປ້ອນຂໍ້ມູນ',
  'Uploading attachments…': 'ກຳລັງອັບໂຫຼດໄຟລ໌ແນບ…',
  'Attachments pending': 'ໄຟລ໌ແນບລໍຖ້າອັບໂຫຼດ',
  '⌘ / Ctrl + Shift + Enter to save & new': '⌘ / Ctrl + Shift + Enter ເພື່ອບັນທຶກ ແລະ ສ້າງໃໝ່',
  'Notes, attachments and more': 'ໝາຍເຫດ, ເອກະສານແນບ ແລະ ອື່ນໆ',
  'Has content': 'ມີຂໍ້ມູນ',
  'Switch section': 'ປ່ຽນສ່ວນ',
  'Open or close Notes, Internal notes, More details, Attachments':
    'ເປີດ ຫຼື ປິດ ໝາຍເຫດ, ໝາຍເຫດພາຍໃນ, ລາຍລະອຽດເພີ່ມເຕີມ, ເອກະສານແນບ',
  'Saved this session': 'ບັນທຶກໃນຮອບນີ້',
  'Recent documents': 'ເອກະສານຫຼ້າສຸດ',
  Open: 'ເປີດ',
  'This session': 'ຮອບນີ້',
  'All documents': 'ເອກະສານທັງໝົດ',
  'Show documents': 'ສະແດງເອກະສານ',
  'View all': 'ເບິ່ງທັງໝົດ',
  'Back to entry': 'ກັບໄປປ້ອນຂໍ້ມູນ',
  'Your entry in progress is kept.': 'ລາຍການທີ່ກຳລັງປ້ອນຍັງຄົງຢູ່.',
  'Search by number or partner…': 'ຄົ້ນຫາຕາມເລກທີ ຫຼື ຄູ່ຄ້າ…',
  'No documents match your search.': 'ບໍ່ພົບເອກະສານທີ່ກົງກັບການຄົ້ນຫາ.',
  'Could not load documents.': 'ບໍ່ສາມາດໂຫຼດເອກະສານໄດ້.',
  'Each saved document appears here immediately.': 'ເອກະສານທີ່ບັນທຶກຈະສະແດງຢູ່ນີ້ທັນທີ.',
  'Ready for your first document': 'ພ້ອມສຳລັບເອກະສານທຳອິດ',
  'No documents saved yet': 'ຍັງບໍ່ມີເອກະສານທີ່ບັນທຶກ',
  'Partner / description': 'ຄູ່ຄ້າ / ລາຍລະອຽດ',
  'Save & new adds the document here and clears the form for the next entry.':
    'ບັນທຶກ ແລະ ສ້າງໃໝ່ ຈະເພີ່ມເອກະສານຢູ່ນີ້ ແລະ ລ້າງຟອມເພື່ອປ້ອນລາຍການຕໍ່ໄປ.',
  'Session total': 'ຍອດລວມໃນຮອບນີ້',
  'Save & new keeps the date, currency and account settings. Other details start fresh.':
    'ບັນທຶກ ແລະ ສ້າງໃໝ່ ຈະຮັກສາວັນທີ, ສະກຸນເງິນ ແລະ ການຕັ້ງຄ່າບັນຊີ. ລາຍລະອຽດອື່ນເລີ່ມໃໝ່.',
  'Discard unsaved changes?': 'ຍົກເລີກການປ່ຽນແປງທີ່ຍັງບໍ່ບັນທຶກ?',
  'Your current entry has unsaved changes. Documents already saved in this session are kept.':
    'ລາຍການປັດຈຸບັນມີການປ່ຽນແປງທີ່ຍັງບໍ່ບັນທຶກ. ເອກະສານທີ່ບັນທຶກແລ້ວໃນຮອບນີ້ຍັງຄົງຢູ່.',
  Saved: 'ບັນທຶກແລ້ວ',
  'Record details': 'ລາຍລະອຽດລາຍການ',
  'Contact details': 'ຂໍ້ມູນຕິດຕໍ່',
  'Billing details': 'ຂໍ້ມູນການອອກໃບບິນ',
  Pricing: 'ການກຳນົດລາຄາ',
  'Stock details': 'ຂໍ້ມູນສະຕັອກ',
  Employment: 'ຂໍ້ມູນການຈ້າງງານ',
  'Payment details': 'ຂໍ້ມູນການຈ່າຍເງິນ',
  'Salary & benefits': 'ເງິນເດືອນ ແລະ ສະຫວັດດີການ',
  'Tax & social security': 'ພາສີ ແລະ ປະກັນສັງຄົມ',
  'Valuation & depreciation': 'ມູນຄ່າ ແລະ ຄ່າຫຼຸ້ຍຫ້ຽນ',
  'Cost allocation': 'ການແບ່ງປັນຕົ້ນທຶນ',
  'Payroll period': 'ໄລຍະເງິນເດືອນ',
  'Personal details': 'ຂໍ້ມູນສ່ວນຕົວ',
  'Accounting entries': 'ລາຍການບັນຊີ',
  'Amount in LAK': 'ຈຳນວນເງິນເປັນກີບ',
  'Remove line': 'ລຶບແຖວ',
  Difference: 'ສ່ວນຕ່າງ',
  'Add the details below, then save when ready.': 'ປ້ອນຂໍ້ມູນດ້ານລຸ່ມ ແລ້ວບັນທຶກເມື່ອພ້ອມ.',
  // Errors, session and connectivity
  'Request ID': 'ລະຫັດຄຳຂໍ',
  'Copy request ID': 'ສຳເນົາລະຫັດຄຳຂໍ',
  'Copy ID': 'ສຳເນົາລະຫັດ',
  Copy: 'ສຳເນົາ',
  Copied: 'ສຳເນົາແລ້ວ',
  'Reload page': 'ໂຫຼດໜ້າໃໝ່',
  'Try again': 'ລອງອີກຄັ້ງ',
  'Clear search': 'ລຶບການຄົ້ນຫາ',
  'No previous period': 'ບໍ່ມີໄລຍະກ່ອນໜ້າ',
  'Something went wrong': 'ມີບາງຢ່າງຜິດພາດ',
  'Unexpected error': 'ເກີດຂໍ້ຜິດພາດທີ່ບໍ່ຄາດຄິດ',
  'A new version of LFB is available': 'ມີ LFB ເວີຊັນໃໝ່',
  'Reload the page to continue with the latest version.': 'ໂຫຼດໜ້າໃໝ່ເພື່ອໃຊ້ເວີຊັນລ່າສຸດຕໍ່.',
  'Cannot reach LFB': 'ບໍ່ສາມາດເຊື່ອມຕໍ່ LFB ໄດ້',
  'Check your internet connection, then try again.': 'ກວດສອບອິນເຕີເນັດ ແລ້ວລອງອີກຄັ້ງ.',
  'Your session expired': 'ໝົດເວລາເຂົ້າສູ່ລະບົບແລ້ວ',
  'Sign in again to continue.': 'ກະລຸນາເຂົ້າລະບົບອີກຄັ້ງເພື່ອດຳເນີນການຕໍ່.',
  'You don’t have access to this': 'ທ່ານບໍ່ມີສິດເຂົ້າເຖິງສ່ວນນີ້',
  'Ask a workspace owner if you need this permission.':
    'ຂໍສິດຈາກເຈົ້າຂອງທຸລະກິດ ຖ້າທ່ານຕ້ອງການໃຊ້ສ່ວນນີ້.',
  'Not found': 'ບໍ່ພົບຂໍ້ມູນ',
  'This changed while you were working': 'ຂໍ້ມູນນີ້ຖືກປ່ຽນແປງໃນຂະນະທີ່ທ່ານກຳລັງແກ້ໄຂ',
  'Reload to see the latest version.': 'ໂຫຼດໃໝ່ເພື່ອເບິ່ງຂໍ້ມູນລ່າສຸດ.',
  'Too many requests': 'ມີຄຳຂໍຫຼາຍເກີນໄປ',
  'Wait a moment, then try again.': 'ລໍຖ້າຈັກໜ້ອຍ ແລ້ວລອງອີກຄັ້ງ.',
  'Please check your input': 'ກະລຸນາກວດສອບຂໍ້ມູນທີ່ປ້ອນ',
  'Something went wrong on our side': 'ລະບົບຂອງພວກເຮົາມີບັນຫາ',
  'Try again. If it keeps happening, contact support with the request ID.':
    'ລອງອີກຄັ້ງ. ຖ້າຍັງເກີດຂຶ້ນ ໃຫ້ຕິດຕໍ່ຝ່າຍຊ່ວຍເຫຼືອພ້ອມລະຫັດຄຳຂໍ.',
  'You are offline. Check your connection and try again.':
    'ທ່ານບໍ່ໄດ້ເຊື່ອມຕໍ່ອິນເຕີເນັດ. ກວດສອບການເຊື່ອມຕໍ່ ແລ້ວລອງອີກຄັ້ງ.',
  'Unable to reach LFB. Check your connection and try again.':
    'ບໍ່ສາມາດເຊື່ອມຕໍ່ LFB ໄດ້. ກວດສອບການເຊື່ອມຕໍ່ ແລ້ວລອງອີກຄັ້ງ.',
  'The service is temporarily unavailable. Please try again.':
    'ບໍລິການບໍ່ພ້ອມໃຊ້ງານຊົ່ວຄາວ. ກະລຸນາລອງອີກຄັ້ງ.',
  'Unable to complete this request': 'ບໍ່ສາມາດດຳເນີນການຄຳຂໍນີ້ໄດ້',
  'You are offline': 'ທ່ານບໍ່ໄດ້ເຊື່ອມຕໍ່ອິນເຕີເນັດ',
  'Back online': 'ເຊື່ອມຕໍ່ອິນເຕີເນັດແລ້ວ',
  'You can keep reading, but changes can’t be saved until you reconnect.':
    'ທ່ານຍັງເບິ່ງຂໍ້ມູນໄດ້ ແຕ່ຈະບັນທຶກການປ່ຽນແປງບໍ່ໄດ້ຈົນກວ່າຈະເຊື່ອມຕໍ່ຄືນ.',
  Offline: 'ບໍ່ໄດ້ເຊື່ອມຕໍ່',
  Dismiss: 'ປິດແຈ້ງເຕືອນ',
  'This page couldn’t be displayed': 'ບໍ່ສາມາດສະແດງໜ້ານີ້ໄດ້',
  'Your data is safe. Try again, or go back to the overview.':
    'ຂໍ້ມູນຂອງທ່ານປອດໄພ. ລອງອີກຄັ້ງ ຫຼື ກັບໄປໜ້າພາບລວມ.',
  'Go to overview': 'ໄປໜ້າພາບລວມ',
  'Technical details': 'ລາຍລະອຽດທາງເຕັກນິກ',
  'This record was changed by someone else': 'ລາຍການນີ້ຖືກແກ້ໄຂໂດຍຄົນອື່ນ',
  'Reload to see the latest version and discard your edits, or overwrite it with your version.':
    'ໂຫຼດໃໝ່ເພື່ອເບິ່ງຂໍ້ມູນລ່າສຸດ ແລະ ຍົກເລີກການແກ້ໄຂຂອງທ່ານ ຫຼື ບັນທຶກທັບດ້ວຍຂໍ້ມູນຂອງທ່ານ.',
  'Reload latest': 'ໂຫຼດຂໍ້ມູນລ່າສຸດ',
  'Overwrite with mine': 'ບັນທຶກທັບດ້ວຍຂອງຂ້ອຍ',
  'Enter a valid number': 'ປ້ອນຕົວເລກໃຫ້ຖືກຕ້ອງ',
  'Value is too small': 'ຄ່ານ້ອຍເກີນໄປ',
  'Value is too large': 'ຄ່າໃຫຍ່ເກີນໄປ',
  'Page not found': 'ບໍ່ພົບໜ້ານີ້',
  'Module not found': 'ບໍ່ພົບໂມດູນ',
  'Setting not found': 'ບໍ່ພົບການຕັ້ງຄ່າ',
  'No active workspace. Ask your administrator to add you to a workspace.':
    'ບໍ່ມີພື້ນທີ່ທຸລະກິດທີ່ໃຊ້ງານໄດ້. ຂໍໃຫ້ຜູ້ດູແລເພີ່ມທ່ານເຂົ້າພື້ນທີ່ທຸລະກິດ.',
  'Platform administrator access is required.': 'ຕ້ອງມີສິດຜູ້ດູແລລະບົບ.',
  'Select date': 'ເລືອກວັນທີ',
  'Clear date': 'ລ້າງວັນທີ',
  'Previous month': 'ເດືອນກ່ອນ',
  'Next month': 'ເດືອນຖັດໄປ',
  Week: 'ອາທິດ',
  Today: 'ມື້ນີ້',
  Selected: 'ເລືອກແລ້ວ',
  'Drop files here or click to browse': 'ວາງໄຟລ໌ຢູ່ນີ້ ຫຼື ກົດເພື່ອເລືອກ',
  'Processing image…': 'ກຳລັງບີບອັດຮູບ…',
  'PDF, images or CSV · 5 MB per file · images compressed automatically':
    'PDF, ຮູບ ຫຼື CSV · 5 MB ຕໍ່ໄຟລ໌ · ບີບອັດຮູບອັດຕະໂນມັດ',
  'Compressed from': 'ບີບອັດຈາກ',
  'Uploading…': 'ກຳລັງອັບໂຫຼດ…',
  Uploaded: 'ອັບໂຫຼດແລ້ວ',
  'Remove file': 'ລຶບໄຟລ໌',
  'Choose one image at a time.': 'ເລືອກເທື່ອລະໜຶ່ງຮູບ.',
  'JPEG, PNG or WebP · compressed automatically': 'JPEG, PNG ຫຼື WebP · ບີບອັດອັດຕະໂນມັດ',
  'Replace image': 'ປ່ຽນຮູບ',
  'Remove image': 'ລຶບຮູບ',
  'Back to top': 'ກັບໄປດ້ານເທິງ',
  Showing: 'ສະແດງ',
  of: 'ຈາກ',
  'Records loaded': 'ລາຍການທີ່ໂຫຼດແລ້ວ',
  'Loading more…': 'ກຳລັງໂຫຼດເພີ່ມ…',
  'Could not load more records. Please retry.': 'ບໍ່ສາມາດໂຫຼດລາຍການເພີ່ມໄດ້. ກະລຸນາລອງໃໝ່.',
  'Scroll for more': 'ເລື່ອນລົງເພື່ອໂຫຼດເພີ່ມ',
  'Load more': 'ໂຫຼດເພີ່ມ',
  'Show all': 'ສະແດງທັງໝົດ',
  'All records loaded': 'ໂຫຼດທຸກລາຍການແລ້ວ',
  'Excel or CSV · 5 MB · up to 500 rows': 'Excel ຫຼື CSV · 5 MB · ສູງສຸດ 500 ແຖວ',
  'Choose one import file at a time.': 'ເລືອກໄຟລ໌ນຳເຂົ້າເທື່ອລະໜຶ່ງໄຟລ໌.',
  'Choose an Excel or CSV file.': 'ເລືອກໄຟລ໌ Excel ຫຼື CSV.',
  'Choose a JPEG, PNG or WebP image.': 'ເລືອກຮູບ JPEG, PNG ຫຼື WebP.',
  'Choose a PDF, JPEG, PNG, WebP or CSV file.': 'ເລືອກໄຟລ໌ PDF, JPEG, PNG, WebP ຫຼື CSV.',
  'This file is empty. Choose another file.': 'ໄຟລ໌ນີ້ຫວ່າງເປົ່າ. ເລືອກໄຟລ໌ອື່ນ.',
  'Choose an image smaller than 50 MB.': 'ເລືອກຮູບທີ່ນ້ອຍກວ່າ 50 MB.',
  'Each attachment must be 5 MB or smaller': 'ແຕ່ລະໄຟລ໌ຕ້ອງບໍ່ເກີນ 5 MB',
  'The file could not be read. Choose another file.': 'ບໍ່ສາມາດອ່ານໄຟລ໌ໄດ້. ເລືອກໄຟລ໌ອື່ນ.',
  'This image could not be read. Choose another image.': 'ບໍ່ສາມາດອ່ານຮູບໄດ້. ເລືອກຮູບອື່ນ.',
  'This browser could not process the image.': 'ບຣາວເຊີນີ້ບໍ່ສາມາດປະມວນຜົນຮູບໄດ້.',
  'The image is still too large. Choose a smaller image.': 'ຮູບຍັງໃຫຍ່ເກີນໄປ. ເລືອກຮູບທີ່ນ້ອຍກວ່າ.',
  Logo: 'ໂລໂກ້',
  'Company stamp': 'ກາປະທັບບໍລິສັດ',
  Signature: 'ລາຍເຊັນ',
  'Document details': 'ລາຍລະອຽດເອກະສານ',
  'Required fields marked *': 'ຊ່ອງທີ່ຈຳເປັນມີເຄື່ອງໝາຍ *',
  'Discount & tax': 'ສ່ວນຫຼຸດ ແລະ ພາສີ',
  'Duplicate item': 'ສຳເນົາລາຍການ',
  'Search products or write a custom item below': 'ຄົ້ນຫາສິນຄ້າ ຫຼື ຂຽນລາຍການດ້ານລຸ່ມ',
  'Search and select…': 'ຄົ້ນຫາ ແລະ ເລືອກ…',
  'Type to search · ↑ ↓ to navigate': 'ພິມເພື່ອຄົ້ນຫາ · ↑ ↓ ເພື່ອເລືອກ',
  'Select an option from the list': 'ເລືອກລາຍການຈາກລາຍຊື່',
  'No matches found': 'ບໍ່ພົບລາຍການທີ່ກົງກັນ',
  'Create new': 'ສ້າງໃໝ່',
  'Add the essentials now. You can complete the details later.':
    'ໃສ່ຂໍ້ມູນຫຼັກກ່ອນ. ສາມາດເພີ່ມລາຍລະອຽດອື່ນໄດ້ພາຍຫຼັງ.',
  'Matches the document currency': 'ຕາມສະກຸນເງິນຂອງເອກະສານ',
  'Suggested automatically. You can change it.': 'ແນະນຳໃຫ້ອັດຕະໂນມັດ. ສາມາດປ່ຽນໄດ້.',
  'This code is already used. Enter a different one.': 'ລະຫັດນີ້ຖືກໃຊ້ແລ້ວ. ກະລຸນາໃສ່ລະຫັດອື່ນ.',
  'Created and selected': 'ສ້າງ ແລະ ເລືອກແລ້ວ',
  'Create & select': 'ສ້າງ ແລະ ເລືອກ',
  SKU: 'ລະຫັດສິນຄ້າ (SKU)',
  Service: 'ບໍລິການ',
  Choose: 'ເລືອກ',
  Clear: 'ລ້າງ',
  'Payment terms': 'ເງື່ອນໄຂການຊຳລະ',
  'On receipt': 'ຊຳລະທັນທີ',
  days: 'ມື້',
  'Shown on the document': 'ສະແດງໃນເອກະສານ',
  'Only visible to your team': 'ເຫັນສະເພາະທີມຂອງທ່ານ',
  'More details': 'ລາຍລະອຽດເພີ່ມເຕີມ',
  'Reference, category & tags': 'ອ້າງອີງ, ໝວດໝູ່ ແລະ ແທັກ',
  Summary: 'ສະຫຼຸບ',
  'Saved as a draft. Review before posting.': 'ບັນທຶກເປັນຮ່າງ. ກວດສອບກ່ອນລົງບັນຊີ.',
  Optional: 'ບໍ່ຈຳເປັນ',
  'Custom item': 'ລາຍການກຳນົດເອງ',
  'Choose product': 'ເລືອກສິນຄ້າ',
  'Search products…': 'ຄົ້ນຫາສິນຄ້າ…',
  'Enter an item or service name': 'ປ້ອນຊື່ລາຍການ ຫຼື ບໍລິການ',
  'Add description': 'ເພີ່ມລາຍລະອຽດ',
  'Remove description': 'ລຶບລາຍລະອຽດ',
  'Item description': 'ລາຍລະອຽດລາຍການ',
  'Add details for this item…': 'ເພີ່ມລາຍລະອຽດສຳລັບລາຍການນີ້…',
  'Unit conversion': 'ການປ່ຽນຫົວໜ່ວຍ',
  'Remove item': 'ລຶບລາຍການ',
  '⌘ / Ctrl + Enter to save': '⌘ / Ctrl + Enter ເພື່ອບັນທຶກ',
  'This field is required': 'ຕ້ອງປ້ອນຂໍ້ມູນຊ່ອງນີ້',
  'Write a note…': 'ຂຽນໝາຍເຫດ…',
  Formatting: 'ຈັດຮູບແບບ',
  Bold: 'ຕົວໜາ',
  Italic: 'ຕົວອຽງ',
  Strikethrough: 'ຂີດຂ້າ',
  'Add link': 'ເພີ່ມລິ້ງ',
  Heading: 'ຫົວຂໍ້',
  Quote: 'ຂໍ້ຄວາມອ້າງອີງ',
  Code: 'ລະຫັດ',
  'Bullet list': 'ລາຍການແບບຈຸດ',
  'Numbered list': 'ລາຍການແບບຕົວເລກ',
  'Decrease indent': 'ຫຼຸດການຫຍໍ້ໜ້າ',
  'Increase indent': 'ເພີ່ມການຫຍໍ້ໜ້າ',
  'Clear formatting': 'ລ້າງຮູບແບບ',
  Undo: 'ຍົກເລີກການແກ້ໄຂ',
  Redo: 'ເຮັດຄືນ',
  'Enter a valid web or email link': 'ປ້ອນລິ້ງເວັບ ຫຼື ອີເມວທີ່ຖືກຕ້ອງ',
  'Link URL': 'ທີ່ຢູ່ລິ້ງ',
  Apply: 'ນຳໃຊ້',
  'Remove link': 'ລຶບລິ້ງ',
};
